import { useState } from 'react';
import { faExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Box,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Grid,
  Stack,
} from '@mui/material';
import CustomSlider from '../CustomSlider';
import ModalComponent from '../../../../components/ModalComponent';
import api from '../../../../services/api';
import { useUserContext } from '../../../../contexts/UserContext';

function Withdrawal() {
  // variables
  const { logoutUser } = useUserContext();
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [resetSlider, setResetSlider] = useState(false);
  const [hasVerified, setHasVerified] = useState(false);
  const [isCertainThatWantsToWithdraw, setIsCertainThatWantsToWithdraw] = useState(false);

  // functions
  const handleCancelSubscription = async () => {
    setIsLoading(true);
    await api.post('/v1/plans/withdrawal')
      .then(() => {
        logoutUser();
      }).catch((err) => {
        setErrorMessage(err.message);
      }).finally(() => {
        setIsLoading(false);
      });
  };

  const handleCloseModal = () => {
    setResetSlider(true);
    setIsCertainThatWantsToWithdraw(false);
  };

  const handleChangeHasVerified = () => {
    setHasVerified(!hasVerified);
  };

  // render conditions
  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="90vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box className="py-5 container-fluid">
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
      >
        <Grid item sx={{ marginTop: 2 }}>
          <h1>Membership cancellation</h1>
        </Grid>
        <Grid item sx={{ marginBottom: 2, fontSize: '12px' }}>
          This will process your membership cancellation. Please review the notes below.
        </Grid>
        <Grid item className="text-start">
          <Box
            sx={{
              border: '1px solid rgb(220, 53, 69)',
              padding: '1rem',
            }}
          >
            <h4 className="text-bold text-danger p-2">
              <FontAwesomeIcon className="px-2" icon={faExclamation} />
              Important notes about cancellation
            </h4>
            <p>
              - Cancellation cannot be undone.
              <br />
              - Cancelled accounts cannot be restored.
              <br />
              - After cancellation, all services will become unavailable.
              <br />
              - After cancellation, all created pages will be deleted.
            </p>
          </Box>
        </Grid>
        <Grid
          item
          sx={{
            justifyContent: 'start',
            marginTop: '1rem',
          }}
        >
          <FormControlLabel
            control={(
              <Checkbox
                checked={hasVerified}
                onChange={handleChangeHasVerified}
              />
            )}
            label="I have confirmed"
          />
        </Grid>
        <Grid item>
          <Stack spacing={2} direction="row" sx={{ m: 3 }} alignItems="center">
            <CustomSlider
              disabled={!hasVerified}
              resetSlider={resetSlider}
              setIsCertainThatWantsToWithdraw={setIsCertainThatWantsToWithdraw}
              setResetSlider={setResetSlider}
            />
          </Stack>
        </Grid>
      </Grid>

      <ModalComponent
        title="Cancellation confirmation"
        show={isCertainThatWantsToWithdraw}
        confirmButtonText="Cancel membership"
        onConfirm={handleCancelSubscription}
        closeModal={handleCloseModal}
        errorMessage={errorMessage}
      >
        <span>Are you sure you want to cancel your membership?</span>
      </ModalComponent>
    </Box>
  );
}

export default Withdrawal;
